import { render, staticRenderFns } from "./login-footer.vue?vue&type=template&id=eb6bda2c&scoped=true"
import script from "./login-footer.vue?vue&type=script&lang=js"
export * from "./login-footer.vue?vue&type=script&lang=js"
import style0 from "./login-footer.vue?vue&type=style&index=0&id=eb6bda2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6bda2c",
  null
  
)

export default component.exports